import { USER_SEARCH_START_LOADING, USER_SEARCH_END_LOADING, USER_SEARCH_LOADED, SET_USER_FILTER } from "../constants/UserConstants";
import { USER_START_LOADING, USER_END_LOADING, USER_LOADED } from "../constants/UserConstants";
import { USER_PROFILE_START_LOADING, USER_PROFILE_END_LOADING, USER_PROFILE_LOADED } from "../constants/UserConstants";
import { LOGIN_LOADED } from "../constants/LoginConstants";

import { getApiData, postApiJsonData, postApiFormData, downloadFile } from "../utils/index";
import * as commonActions from "./CommonActions";

export function loadUserSearch(filters, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: USER_SEARCH_START_LOADING });

        try {

            var data = await postApiJsonData("UserProfile/GetPaged", filters, null);
            
            if(data.success) {
                await dispatch({
                    type: USER_SEARCH_LOADED,
                    payload: {
                        dataList: data.responseEntities[0].dataList
                        , searchList: data.responseEntities[0].userSearches
                        , totalCount: data.responseEntities[0].totalCount
                    }
                });
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: USER_SEARCH_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: USER_SEARCH_END_LOADING });
        }
    };
}

export function downloadUserSearch(filters, documentName) {
    return async (dispatch) => {
            
        await dispatch({ type: USER_SEARCH_START_LOADING });

        try {

            var data = await downloadFile("UserProfile/ExportToExcel", filters);
            
            if(data.success) {
                var url = window.URL.createObjectURL(data.file);
                var a = document.createElement('a');
                a.href = url;
                a.download = documentName;
                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                a.click();    
                a.remove();
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }

            await dispatch({ type: USER_SEARCH_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: USER_SEARCH_END_LOADING });
        }
    };
}

export function setUserFilter(filter) {
    return async (dispatch) => {
        await dispatch({
            type: SET_USER_FILTER,
            payload: filter
        });
    };
}

export function loadUser(id, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: USER_START_LOADING });

        try {

            var data = await getApiData("UserProfile/GetUserProfileFBO", { id });
            
            if(data.success) {
                await dispatch({
                    type: USER_LOADED,
                    payload: data.responseEntities[0]
                });
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: USER_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: USER_END_LOADING });
        }
    };
}

export function saveUser(formData, isAdd, navigate, updateUserState) {
    return async (dispatch) => {
        
        await dispatch({ type: USER_START_LOADING });

        try {

            var data = await postApiFormData("UserProfile/SaveUserProfileFBO", null, formData);
            
            if(data.success) {
                if(isAdd) {
                    navigate('/user-edit/' + data.responseEntities[0].userProfile.id);
                    dispatch(commonActions.setSuccessMessage("User Created Successfully!"));
                }
                else {
                    await dispatch({
                        type: USER_LOADED,
                        payload: data.responseEntities[0]
                    });

                    if(updateUserState) {
                        const user_info = JSON.parse(localStorage.getItem('ticketing_user_info'));
                        if(user_info) {
                            user_info.firstName = data.responseEntities[0].userProfile.firstName;
                            user_info.lastName = data.responseEntities[0].userProfile.lastName;
                            user_info.fullName = data.responseEntities[0].userProfile.fullName;
                            
                            user_info.showDraft = data.responseEntities[0].showDraft;
                            user_info.showNew = data.responseEntities[0].showNew;
                            user_info.showInProgress = data.responseEntities[0].showInProgress;
                            user_info.showSalesAction = data.responseEntities[0].showSalesAction;
                            user_info.showPdReview = data.responseEntities[0].showPdReview;
                            user_info.showTechnicalReview = data.responseEntities[0].showTechnicalReview;
                            user_info.showTechnicalSupport = data.responseEntities[0].showTechnicalSupport;
                            user_info.showPendingForSampling = data.responseEntities[0].showPendingForSampling;
                            user_info.showSamplingInProcess = data.responseEntities[0].showSamplingInProcess;
                            user_info.showScheduled = data.responseEntities[0].showScheduled;
                            user_info.showWaitingCorrectiveAction = data.responseEntities[0].showWaitingCorrectiveAction;
                            user_info.showDataReview = data.responseEntities[0].showDataReview;
                            user_info.showPhase1Evaluation = data.responseEntities[0].showPhase1Evaluation;
                            user_info.showPendingForInspection = data.responseEntities[0].showPendingForInspection;
                            user_info.showInspectionInProcess = data.responseEntities[0].showInspectionInProcess;
                            user_info.showNonConformity = data.responseEntities[0].showNonConformity;
                            user_info.showPhase2Evaluation = data.responseEntities[0].showPhase2Evaluation;
                            user_info.showFinalDecision = data.responseEntities[0].showFinalDecision;
                            user_info.showReadyToIssue = data.responseEntities[0].showReadyToIssue;
                            user_info.showCompleted = data.responseEntities[0].showCompleted;
                            user_info.showClosed = data.responseEntities[0].showClosed;
                            user_info.showCancelled = data.responseEntities[0].showCancelled;
                            user_info.showStopped = data.responseEntities[0].showStopped;
                            user_info.showAborted = data.responseEntities[0].showAborted;

                            user_info.showIsoDraft = data.responseEntities[0].showIsoDraft;
                            user_info.showIsoNew = data.responseEntities[0].showIsoNew;
                            user_info.showIsoSalesAction = data.responseEntities[0].showIsoSalesAction;
                            user_info.showIsoCalculateManDays = data.responseEntities[0].showIsoCalculateManDays;
                            user_info.showIsoScheduling = data.responseEntities[0].showIsoScheduling;
                            user_info.showIsoAuditInProgress = data.responseEntities[0].showIsoAuditInProgress;
                            user_info.showIsoDocumentReview = data.responseEntities[0].showIsoDocumentReview;
                            user_info.showIsoTechnicalReview = data.responseEntities[0].showIsoTechnicalReview;
                            user_info.showIsoDecisionMaking = data.responseEntities[0].showIsoDecisionMaking;
                            user_info.showIsoCompleted = data.responseEntities[0].showIsoCompleted;
                            user_info.showIsoClosed = data.responseEntities[0].showIsoClosed;
                            user_info.showIsoAborted = data.responseEntities[0].showIsoAborted;

                            user_info.showIneDraft = data.responseEntities[0].showIneDraft;
                            user_info.showIneNew = data.responseEntities[0].showIneNew;
                            user_info.showInePendingApproval = data.responseEntities[0].showInePendingApproval;
                            user_info.showIneRejected = data.responseEntities[0].showIneRejected;
                            user_info.showIneSalesAction = data.responseEntities[0].showIneSalesAction;
                            user_info.showIneApprovalOfContract = data.responseEntities[0].showIneApprovalOfContract;
                            user_info.showIneIssueWorkOrderForm = data.responseEntities[0].showIneIssueWorkOrderForm;
                            user_info.showInePerformInspection = data.responseEntities[0].showInePerformInspection;
                            user_info.showIneAwaitingSignature = data.responseEntities[0].showIneAwaitingSignature;
                            user_info.showIneCompleted = data.responseEntities[0].showIneCompleted;
                            user_info.showIneClosed = data.responseEntities[0].showIneClosed;
                            user_info.showIneAborted = data.responseEntities[0].showIneAborted;

                            user_info.showIdiDraft = data.responseEntities[0].showIdiDraft;
                            user_info.showIdiNew = data.responseEntities[0].showIdiNew;
                            user_info.showIdiDesignReview = data.responseEntities[0].showIdiDesignReview;
                            user_info.showIdiDesignReviewAccepted = data.responseEntities[0].showIdiDesignReviewAccepted;
                            user_info.showIdiDesignReviewRejected = data.responseEntities[0].showIdiDesignReviewRejected;
                            user_info.showIdiUploadedToBalady = data.responseEntities[0].showIdiUploadedToBalady;
                            user_info.showIdiFoundation = data.responseEntities[0].showIdiFoundation;
                            user_info.showIdiGroundBeam = data.responseEntities[0].showIdiGroundBeam;
                            user_info.showIdiColumns = data.responseEntities[0].showIdiColumns;
                            user_info.showIdiSlab = data.responseEntities[0].showIdiSlab;
                            user_info.showIdiWaterproofing = data.responseEntities[0].showIdiWaterproofing;
                            user_info.showIdiFinishes = data.responseEntities[0].showIdiFinishes;
                            user_info.showIdiProjectCompletion = data.responseEntities[0].showIdiProjectCompletion;
                            user_info.showIdiCompleted = data.responseEntities[0].showIdiCompleted;
                            user_info.showIdiClosed = data.responseEntities[0].showIdiClosed;
                            user_info.showIdiCancelled = data.responseEntities[0].showIdiCancelled;
                            user_info.showIdiAborted = data.responseEntities[0].showIdiAborted;

                            user_info.showIdiInspectionDraft = data.responseEntities[0].showIdiInspectionDraft;
                            user_info.showIdiInspectionPendingForInspection = data.responseEntities[0].showIdiInspectionPendingForInspection;
                            user_info.showIdiInspectionInspectionInProcess = data.responseEntities[0].showIdiInspectionInspectionInProcess;
                            user_info.showIdiInspectionReadyForReview = data.responseEntities[0].showIdiInspectionReadyForReview;
                            user_info.showIdiInspectionUploadToTawuniya = data.responseEntities[0].showIdiInspectionUploadToTawuniya;
                            user_info.showIdiInspectionCompleted = data.responseEntities[0].showIdiInspectionCompleted;
                            user_info.showIdiInspectionClosed = data.responseEntities[0].showIdiInspectionClosed;
                            user_info.showIdiInspectionAborted = data.responseEntities[0].showIdiInspectionAborted;

                            localStorage.setItem("ticketing_user_info", JSON.stringify(user_info));

                            await dispatch({
                                type: LOGIN_LOADED,
                                payload: user_info
                            });
                        }
                    }

                    dispatch(commonActions.setSuccessMessage("User Saved Successfully!"));
                }
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }
                
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: USER_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: USER_END_LOADING });
        }
    };
}

export function loadUserProfile() {
    return async (dispatch) => {
        
        await dispatch({ type: USER_PROFILE_START_LOADING });

        try {

            var data = await getApiData("UserProfile/GetUserProfileEditFBO", null);
            
            if(data.success) {
                await dispatch({
                    type: USER_PROFILE_LOADED,
                    payload: data.responseEntities[0]
                });
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: USER_PROFILE_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: USER_PROFILE_END_LOADING });
        }
    };
}

export function saveUserProfile(fbo) {
    return async (dispatch) => {
        
        await dispatch({ type: USER_PROFILE_START_LOADING });

        try {

            var data = await postApiJsonData("UserProfile/SaveUserProfileEditFBO", null, fbo);
            
            if(data.success) {
                await dispatch({
                    type: USER_PROFILE_LOADED,
                    payload: data.responseEntities[0]
                });

                const user_info = JSON.parse(localStorage.getItem('ticketing_user_info'));
                if(user_info) {
                    user_info.firstName = data.responseEntities[0].firstName;
                    user_info.lastName = data.responseEntities[0].lastName;
                    user_info.fullName = data.responseEntities[0].fullName;

                    localStorage.setItem("ticketing_user_info", JSON.stringify(user_info));

                    await dispatch({
                        type: LOGIN_LOADED,
                        payload: user_info
                    });
                }

                dispatch(commonActions.setSuccessMessage("Profile Saved Successfully!"));
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: USER_PROFILE_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: USER_PROFILE_END_LOADING });
        }
    };
}